import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNoDataErrorWidget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-label="NoDataErrorWidget"
    {...props}
  >
    <circle
      cx={8}
      cy={8}
      r={8}
      fill="var(--color-content-status-neutral-secondary)"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      d="M9 11.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.8-3a.8.8 0 1 0 1.6 0V4a.8.8 0 1 0-1.6 0z"
    />
  </svg>
);
export default SvgNoDataErrorWidget;
